<template>
    <div class="container-fluid">
        <v-title :lineage="[{'Settings':'settings'}]">
            Gateway Accounts
            <div slot="actions">
                <router-link
                    v-if="$auth.$pages['add-gateway-account'].isAllowed"
                    :to="{name: 'add-gateway-account'}"
                    class="btn btn-link">Add Gateway Account<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
            </div>
        </v-title>
        <div class="grid flex-flow-column">
            <div class="grid-item">
                <grid
                    :columns="gridColumns"
                    :filter-set="gridFilterSet"
                    :provider="provider"
                    :tabs="gridTabs"
                    @completed="stopLoadingPage">
                    <v-no-content slot="no-content">
                        <span slot="title">It seems that you have no gateway accounts</span>
                        <span slot="description">You can start processing payments by setting up a gateway account.</span>
                        <div slot="actions">
                            <router-link
                                v-if="$auth.$pages['add-gateway-account'].isAllowed"
                                :to="{name: 'add-gateway-account'}"
                                class="btn btn-link">Add Gateway Account<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
                        </div>
                    </v-no-content>
                </grid>
            </div>
        </div>
    </div>
</template>

<script>
    import {vIcon} from '@/components/form';
    import vNoContent from '@/components/v-no-content';
    import gatewayColumns from './gateway-columns';
    import gatewayFilters from '@/common/query/filter/gateway-account-filter';
    import Grid from '@/components/grid/grid';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import TabsConfiguration from '@/components/grid/tabs/tabs-configuration';
    import vTitle from '@/components/v-title';
    import FilterSet from '@/components/query/filter-set';
    import GatewayAccountModel from '@/common/models/gateway-account-model';

    export default {
        name: 'gateway-accounts',
        components: {
            vTitle, vNoContent, vIcon, Grid,
        },
        mixins: [LoadStateMixin],
        data() {
            return {
                gridColumns: gatewayColumns,
                gridFilterSet: new FilterSet({store: this.$store, ...gatewayFilters}),
                gridTabs: new TabsConfiguration({
                    id: 'gateway-list',
                    store: this.$store,
                    systemTabs: [
                        {
                            label: 'All',
                            sortBy: {createdTime: 'desc'},
                        },
                    ],
                    version: 1,
                    filtersVersion: gatewayFilters.version,
                }),
            };
        },
        methods: {
            provider(params) {
                if (!params.filter || !params.filter.includes('status:')) {
                    params = {filter: `status:!${GatewayAccountModel.Statuses.closed}`, ...params};
                }

                return this.$api(({gatewayAccounts}) => gatewayAccounts.getAll(params));
            },
        },
    };
</script>
